// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import AppContainer from './AppContainer';
import { AuthProvider } from './AuthContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppContainer />
    </AuthProvider>
  </React.StrictMode>
);
